module.exports = __webpack_public_path__ + "img/ab-testing.2fa79cb1.svg";